import "../../../src/App.css";
import PetBreed from "../../components/PetBreed/PetBreed";
import AddPetBreed from "../../components/AddPetBreed/AddPetBreed";
import LeadDataReport from "../../components/LeadDataReport/LeadDataReport";
import React, { useState, useEffect } from "react";
import axios from "axios";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import PaginationLink from "../../components/Pagination/Pagination";
import Wrapper from "../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import  "../../pages/LeadDataReportMaster/LeadDataReportMaster.css";
// import Modal from "../../components/LeadDataReport/LeadDataReport/Modal";
// import AddIcon from '@mui/icons-material/Add';
// import DownloadIcon from '@mui/icons-material/Download';
// import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
// import DatePicker from "react-datepicker";

function LeadDataReportMaster() {
  const [openProfile, setOpenProfile] = useState(false);
 
  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />
       
        <div
          className="container-fluid"
          style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4", width: "100%", overflowX: "auto" }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "1%",
              }}
            >
              <div>
                <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                Lead Report | <HomeOutlinedIcon />{" "}
                  <span style={{ fontSize: "20px" }}>&gt; Report</span>
                </h1>
              </div>
              
            </div>
            <div> 
            <Wrapper className="ViewLeadDetails wrapperLeadDataReport" >                 
                <LeadDataReport                  
                  setOpenProfile={setOpenProfile}
                  openProfile={openProfile}
                />                
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LeadDataReportMaster;
